import {newSet} from '../actions/library/sets'
import {newQuestion} from '../actions/library/questions'
import {getQuestionBodyLabel} from './getQuestionBodyLabel'
import {copyItemFromRepoEvent} from './analytics/copyItemFromRepoEvent'



const SET_TITLE_MAX_CHARACTER_LENGTH=60

export function addCopyToLibrary(item,instigatedBy) {
	const nowDate = new Date()

	if(item.choices){
		const requestBody = {
			...item,
			'body':`${getQuestionBodyLabel(item)}`,
			'userCreated': nowDate,
			'clientModified':nowDate,
			'folder':null,
			repo:null
		}
		copyItemFromRepoEvent(item,instigatedBy)
		return newQuestion(requestBody)
	}
	else if(item.questions){
		const newSetName=`${item.name} Copy`
		const requestBody = {
			...item,
			'name':newSetName.substring(0, SET_TITLE_MAX_CHARACTER_LENGTH),
			'userCreated': nowDate,
			'folder':null,
			'clientModified':nowDate,
			repo:null
		}
		copyItemFromRepoEvent(item,instigatedBy)
		return newSet(requestBody)

	}

}



    